import React from 'react';

import { WHAT_I_DO } from 'constants/texts';
import { SECTIONS } from 'constants/sections';

import Section from 'components/Section';
import MarkdownParser from 'components/MarkdownParser';

import './styles.scss';

function WhatIDo() {
  return (
    <Section name={SECTIONS.WHAT_I_DO.name}>
      <div className="first-column">
        <h1 className="title">{WHAT_I_DO.title}</h1>
        <p className="paragraph">
          <MarkdownParser>
            {WHAT_I_DO.content}
          </MarkdownParser>
        </p>
      </div>
    </Section>
  )
}

export default WhatIDo;
